/* eslint-disable no-underscore-dangle */
import pgrid from 'projection-grid';
import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { DeterministicView, helpers } from '@bingads-webui/deterministic-view';
import { paginationPlugin } from '@bingads-webui/projection-grid-pagination';
import { toolbarPlugin } from '@bingads-webui/projection-grid-toolbar';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import InformationView from './Information-view';
import template from './hotel-view-template.pug';
import CustomFilterView from '../assignment-utils/custom-filter-view';

const i18n = globalContext.require('component/i18n/loader!campaignui/feature/hotel-center');
const { crossPageSelectAllPlugin } = globalContext.require('component/bingads-grid/plugin/cross-page-select-all/index');

/**
 * Class representing a navigation tabs for HotelViewBase
 * @extends View
 */
export default class HotelViewBase extends DeterministicView {
  /**
  * Initializes HotelsInGroupView
  * @returns {undefined}
  */
  initialize() {
    this.i18n = i18n;

    const hotelGroupInformation = new InformationView({ name: 'hotelGroupInfo' });

    hotelGroupInformation.setState({ groupName: undefined, count: undefined });
    this.setChild('group-information', hotelGroupInformation);
  }

  setState({
    groupId,
    groupName,
    excludeGroupId,
    showEditMenu,
    subAccountId,
    isSubAccountSelected,
  }) {
    this.getChild('group-information').setState({ groupName, count: undefined });

    this.model.set('groupId', groupId);
    this.model.set('groupName', groupName);
    this.model.set('excludeGroupId', excludeGroupId);
    this.model.set('showEditMenu', showEditMenu);
    this.model.set('subAccountId', subAccountId);
    this.model.set('isSubAccountSelected', isSubAccountSelected);
  }

  get template() {
    return template;
  }

  renderTrunk() {
    super.renderTrunk();

    // Do not attempt to render if no group is assigned yet.
    if (!this.getState().groupId) {
      return;
    }

    this.gridFactory = pgrid.factory({ vnext: true })
      .use(toolbarPlugin)
      .use(paginationPlugin)
      .use(uiBlockerPlugin)
      .use(crossPageSelectAllPlugin);
  }

  getSelectedItems() {
    if (this.grid.gridView) {
      return this.grid.gridView.selectedItems();
    }

    return null;
  }

  getSelectionCount() {
    return this.grid.crossPageSelectAll && this.grid.crossPageSelectAll.isAllSelected ?
      this.grid.crossPageSelectAll.viewModel.totalRowsTotalPageCount() :
      _.result(this.getSelectedItems(), 'length', 0);
  }

  getFilter() {
    const filter = this.filterAgent.filterService.getCombinedFilter();
    if (_.isEmpty(filter) || _.isEmpty(filter.query)) {
      return filter;
    }
    const mapper = condition => _.chain(condition)
      .pairs()
      .map(pair => [_.result({
        Name: 'HotelName',
      }, pair[0], pair[0]), pair[1]])
      .object()
      .value();
    const converter = (query) => {
      /* query demo with $and:
        {
          "$and": [{
            "Status": { "$eq": "Enum.Status'Active'" }
          },{
            "Name": { "$contains": "A12" }
          }]
        }
        query demo withou $and:
        {
          "Status": { "$eq": "Enum.Status'Active'" }
        }
        Exclude status filter which is not supported in bulk edit API yet.
      */
      if (_.has(query, '$and')) {
        return _.defaults({
          $and: _.chain(query.$and)
            .reject(condition => _.has(condition, 'Status'))
            .map(mapper)
            .value(),
        }, query);
      }
      return _.isObject(query) ? _.omit(query, 'Status') : _.chain(query)
        .omit('Status')
        .map(mapper)
        .value();
    };
    return _.defaults({
      query: converter(filter.query),
    }, filter);
  }

  clearSelection() {
    if (this.grid.gridView) {
      this.grid.gridView.deselectAll();
    }
  }

  refreshGrid() {
    this.grid.gridView.refresh(true);
  }


  gridCreated() {
    this.grid.gridView.on('didUpdate', () => {
      this.hotelCount = this.grid.gridView.totalCountRows;

      helpers.updateView(this.getChild('group-information'), { count: this.hotelCount });
    });
  }

  onSearchInvoked(searchTerm) {
    this.searchTerm = searchTerm;
    if (_.isEmpty(this.searchTerm)) {
      return;
    }
    this.filterAgent.filterService.setEditableFilter({
      [this.searchPropertyName]: { $contains: searchTerm },
    });
    this._tryRenderFilterAndInsert();
  }

  _initialRenderFilter(searchPropertyName) {
    this.filterStateView = new CustomFilterView();

    const currentFilter = this.getFilter();
    if (currentFilter && currentFilter.query && currentFilter.query[searchPropertyName]) {
      this.filterStateView.setState({ filterValue: currentFilter.query[searchPropertyName].$contains });
      this.filterStateView.render();

      this._removeSearchItems();// clean the exist search items
      this.filterStateView.$el.appendTo(this.$('.toolbar-container'));

      this.listenTo(this.filterStateView, 'filterRemoved', this.onFilterRemoved);
    }
  }

  _tryRenderFilterAndInsert() {
    this.filterStateView = new CustomFilterView();

    this.filterStateView.setState({ filterValue: this.searchTerm });
    this.filterStateView.render();

    this._removeSearchItems();// clean the exist search items
    this.filterStateView.$el.appendTo(this.$('.toolbar-container'));

    this.listenTo(this.filterStateView, 'filterRemoved', this.onFilterRemoved);
  }


  _removeSearchItems() {
    // remove the last item (which is the filter state)
    while (this.$('.toolbar-container').children().length > 1) {
      this.$('.toolbar-container').children().last().remove();
    }
  }

  onFilterRemoved() {
    this.searchTerm = null;
    this._clearSearchBox();

    this.filterAgent.filterService.removeEditableFilter();
  }

  _clearSearchBox() {
    this.filterToolbar.update({ id: 'search-box-filter', value: '' });
    this._removeSearchItems();
  }
}
